import { render, staticRenderFns } from "./TagArchiveView.vue?vue&type=template&id=203bc446&scoped=true&"
import script from "./TagArchiveView.vue?vue&type=script&lang=ts&"
export * from "./TagArchiveView.vue?vue&type=script&lang=ts&"
import style0 from "./TagArchiveView.vue?vue&type=style&index=0&id=203bc446&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203bc446",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer,VRow})
